import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { TRUST_BADGES } from './salesData';
interface TrustStripProps {
  className?: string;
}

/** Banda de sellos que refuerza el valor percibido. Se repite en la página. */
export function TrustStrip({
  className = ''
}: TrustStripProps) {
  return <ul className={`flex flex-wrap items-center gap-x-5 gap-y-2.5 ${className}`} aria-label="Características de KETO 4P" data-id="element-187" data-mp="2fcah2yh3eg38">
      {TRUST_BADGES.map(badge => <li key={badge} className="flex items-center gap-1.5 font-display text-[0.6rem] uppercase tracking-editorial text-bone/70" data-id="element-188" data-mp="25dkx905mylkc">
          <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={2.5} data-id="element-189" data-mp="20ei1y7fgjtpk" />
          {badge}
        </li>)}
    </ul>;
}